export default __webpack_public_path__ + "static/media/paging_prev.87d526f7.svg";